export default {
  store_namespace: 'group',
  auth_feature: 'group',
  new_route_name: "AdminGroupNew",
  edit_route_name: "AdminGroupEdit",
  detail_route_name: "AdminGroupDetail",
  csv_export_filename_prefix: 'group',
  hide_action_new_button: false,
  hide_action_pdf_button: true,
  hide_action_edit_button: false,
  hide_action_delete_button: false,
  export_csv: true,
  export_pdf: true,
  duplications: true,
  title_field: 'name',
  sort_by: 'name',
  sort_desc: false,
  fields: [
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      sortable: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'families',
      label: "Famille",
      type: 'group_repeater',
      inForm: true,
      required: false,
      canDrag: false,
      fields: [{
        name: 'id',
        label: "group.product-family",
        type: 'select',
        inForm: true,
        required: true,
      },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Group/config.js